import Vue from 'vue';
import App from './App.vue';
import Vuetify from 'vuetify';
import router from './router'
import { store } from './store/storeMain';
import Vuelidate from 'vuelidate';
import 'babel-polyfill';


Vue.use(Vuetify, {
  theme: {
    primary: "#2196F3",
    secondary: "#26A69A",
    accent: "#80CBC4",
    error: "#f44336",
    warning: "#ffeb3b",
    info: "#2196f3",
    success: "#4caf50"
  }
});

Vue.use(Vuelidate);

Vue.config.productionTip = false


new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store: store
})



// WEBPACK FOOTER //
// ./src/main.js